import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  // NOTE: コースにつき1プラン。サーバーが同一コースを上書きし、別コースのプランは併存させる
  updateExtensionPlan({ tableId, extensionPlan }) {
    return axiosIns.put(
      `/waiter/tables/${tableId}/extension_plan`,
      snakecaseKeys({ extensionPlan }),
    )
  },
  // NOTE: courseVendibleId指定でそのコースのプランだけ解除。省略すると全プランを解除する
  deleteExtensionPlan({ tableId, courseVendibleId = null }) {
    return axiosIns.delete(`/waiter/tables/${tableId}/extension_plan`, {
      params: courseVendibleId ? snakecaseKeys({ courseVendibleId }) : {},
    })
  },
}
